import { render, staticRenderFns } from "./ReceitaCreate.vue?vue&type=template&id=00a4540c"
import script from "./ReceitaCreate.vue?vue&type=script&lang=js"
export * from "./ReceitaCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports